import { baseService } from "cortex/ui/src/service/base";

interface DeviceEventsFilters {
  name?: string;
  priority?: string | number;
  source?: string | number;
}

export const deviceEventsService = {
  load(deviceId: string | number, first: string, last: string) {
    const parts = ["", "api", "device", "events", deviceId];
    if (first) {
      parts.push(first);
      parts.push(last);
    }
    return baseService.get(parts.join("/"));
  },

  loadV3(
    deviceId: string | number,
    start: string,
    end: string,
    filters: DeviceEventsFilters = {},
  ) {
    return baseService.get(`/api/device/events/v3/${deviceId}`, {
      ...(start && { start }),
      ...(end && { end }),
      eventName: filters.name,
      severity: filters.priority,
      sourceId: filters.source,
    });
  },
};

export default deviceEventsService;
